








































































































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import vSelect from 'vue-select';
import { required, maxLength } from 'vuelidate/lib/validators';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import Toast from '@/components/display/toast.vue';

import { FormulasApi, Formula } from '../../../../../api';

@Component({
	components: {
		secondaryNav,
		vSelect,
		Toast,
	},
	validations: {
		form: {
			name: { required },
			formula: { required },
			inputs: { required },
			entityType: { required },
			sensorType: { required },
		},
	},
	mixins: [validationMixin],
})
export default class FormulaUpdate extends Vue {
	public form = {
		id: -1,
		name: '',
		formula: '',
		inputs: '',
		archived: false,
		entityType: '',
		sensorType: '',
	};
	public formula: Formula | null = null;
	public loading = true;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;

	private api: FormulasApi;

	public entityTypes = ['tanks', 'vats'];
	public sensorTypes = ['capacitance', 'distance'];

	constructor() {
		super();
		this.api = new FormulasApi();
	}

	public async onSubmit(e: Event) {
		e.preventDefault();
		this.$v.$touch();
		if (this.$v.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}
		this.submitStatus = 'PENDING';

		const { formulaId } = this.$route.params;
		const formula: Formula = this.form;
		formula.id = this.form.id;
		formula.name = this.form.name;
		formula.formula = this.form.formula;
		formula.inputs = this.form.inputs;
		formula.archived = this.form.archived;
		formula.entityType = this.form.entityType;
		formula.sensorType = this.form.sensorType;

		try {
			const response = await new FormulasApi().updateFormula(parseInt(formulaId, 10), {
				data: formula,
			});
		} catch (e) {
			const error = e.response.data.errors.name[0];
			new Toast().makeToast(error, 'Error Updating Formula', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}

		new Toast().makeToast('Formula Updated', 'Successfully updated', 'success');

		setTimeout(() => {
			this.submitStatus = 'OK';
			this.$router.push({ name: 'formulas.view', params: { formulaId } });
		}, 1000);
	}

	public async load() {
		const { formulaId } = this.$route.params;
		this.loading = true;

		try {
			const response = await this.api.getFormulaById(parseInt(formulaId, 10));
			const formula: Formula = response.data;
			this.form.id = formula.id;
			this.form.name = formula.name;
			this.form.formula = formula.formula ?? '';
			this.form.inputs = formula.inputs ?? '';
			this.form.archived = formula.archived ?? false;
			this.form.entityType = formula.entityType ?? 'tanks';
			this.form.sensorType = formula.sensorType ?? 'capacitance';
		} catch (e) {
			this.formula = null;
		} finally {
			this.loading = false;
		}
	}

	public created() {
		this.load();
	}
}
